import type { PendingLetterInstructor } from '@features/instructors/api/get-instructors-pending-letter/getInstructorsPendingLetter.types';

import type { ApprovalLetterRow } from './InstructorApprovalLetterPanel.types';

function mapPendingLetterToRows(
  instructors: PendingLetterInstructor[]
): ApprovalLetterRow[] {
  return instructors.flatMap(instructor =>
    instructor.programs.map(program => ({
      instructorId: instructor.instructorId,
      firstName: instructor.firstName,
      lastName: instructor.lastName,
      displayName: instructor.displayName,
      location: instructor.primaryTrainingCenter.name,
      programId: program.id,
      caseId: program.caseId,
    }))
  );
}

export { mapPendingLetterToRows };
